'use client';

import HugSvg from '@/assets/hug.svg';
import { Suggestions } from './Suggestions';
import { memo } from 'react';

/**
 * Initial welcome screen shown when no messages are present
 */
function GettingStartedComponent() {
  return (
    <div className="text-center">
      <HugSvg className="w-24 mx-auto mt-12" />
      <h3 className="font-medium text-xl mt-4">How can I help today?</h3>
      <h4 className="font-medium mt-6">Suggestions</h4>
      <Suggestions />
    </div>
  );
}

export const GettingStarted = memo(GettingStartedComponent);